export default "__VITE_ASSET__DGYXEp0P__"